import { BaseReactiveClass } from 'Classes/BaseReactiveClass';
import { ModelAccountWalletTransaction } from './ModelAccountWalletTransaction';

export class ModelAccountWalletBalance extends BaseReactiveClass {
  static TYPE_BALANCE = 'balance';
  static TYPE_BANK = 'bank';

  get isWalletFundingSource() {
    return true;
  }

  get isTypeBalance() {
    return true;
  }

  get name() {
    return 'Balance';
  }

  get type() {
    return 'balance';
  }

  get currentBalance() {
    return this.value || 0;
  }

  get pendingBalance() {
    return this.pending || 0;
  }

  get investmentPendingBalance() {
    return this.pending_investments || 0;
  }

  get isCurrentBalanceZero() {
    return this.currentBalance === 0;
  }

  get totalBalance() {
    return this.currentBalance + this.pendingBalance - this.investmentPendingBalance;
  }

  get isTotalBalancePositive() {
    return this.totalBalance > 0;
  }

  get transactions() {
    return this._transactions || [];
  }

  set transactions(transactionsData) {
    const transactions = transactionsData.map(item => (
      item instanceof ModelAccountWalletTransaction
        ? item
        : new ModelAccountWalletTransaction(item)
    ));
    this.$set('_transactions', transactions);
  }

  // eslint-disable-next-line camelcase
  get pending_transactions() {
    return this._pending_transactions || [];
  }

  // eslint-disable-next-line camelcase
  set pending_transactions(transactionsData) {
    const transactions = transactionsData.map(item => (
      item instanceof ModelAccountWalletTransaction
        ? item
        : new ModelAccountWalletTransaction(item)
    ));
    this.$set('_pending_transactions', transactions);
  }
}
